/**
 * @generated SignedSource<<47dff88580a488858c2db8e2c64ed6ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "withdrawImpulseByClaim",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "withdraw",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseDialogSubscriptionImpulseImplMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseDialogSubscriptionImpulseImplMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f4273b78a1c7b8a110f57c0bdfb366e",
    "id": null,
    "metadata": {},
    "name": "ImpulseDialogSubscriptionImpulseImplMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseDialogSubscriptionImpulseImplMutation(\n  $request: WithdrawImpulseByClaimRequestInput\n) {\n  withdrawImpulseByClaim(request: $request) {\n    id\n    version\n    withdraw\n  }\n}\n"
  }
};
})();

node.hash = "ad9c796c5f75e8d424eaf9f21fb6204a";

module.exports = node;
